export default {
    state: {
        cartItems: 0,
        message: {
            text: '',
            type: 0,
        },
        cart: {
            plans: [],
            total: 0,
            currency: '',
        },
    },
    actions: {
        SET_COUPON({ commit }, payload) {
            const { id, code } = payload;
            return window.axios
                .post(`api/checkout/coupon/${id}/${code}`)
                .then((res) => {
                    commit('SET_COUPON_MESSAGE', {
                        message: {
                            text: res.data.message.text,
                            type: res.data.message.type,
                        },
                    });
                    commit('SET_CART', {
                        plans: res.data.items,
                        total: res.data.total,
                    });

                    return res;
                })
                .catch((err) => {
                    commit('SET_COUPON_MESSAGE', {
                        message: {
                            text: err.response.data.text,
                            type: err.response.data.type,
                        },
                    });
                    return err;
                });
        },
        REMOVE_COUPON({ commit }, payload) {
            const { code } = payload;
            return window.axios
                .delete(`api/checkout/remove/coupon/${code}`)
                .then((res) => {
                    commit('SET_CART', {
                        plans: res.data.items,
                        total: res.data.total,
                    });
                })
                .catch((err) => {
                    console.error('[REMOVE_COUPON]::', err);
                });
        },
        GET_CART({ commit }, payload) {
            return window.axios
                .get('api/cart/items', {
                    params: {
                        code: payload.currency,
                        invoice_id: payload.invoice_id,
                    },
                })
                .then((res) => {
                    commit('SET_CART', {
                        plans: res.data.items,
                        total: res.data.total,
                    });
                })
                .catch((err) => {
                    console.error('[GET_CART]::', err);
                });
        },
        REMOVE_ITEM({ commit }, payload) {
            return window.axios
                .delete(`api/cart/remove/${payload}`)
                .then((res) => {
                    commit('SET_CART', {
                        plans: res.data.cart,
                        total: res.data.total,
                    });
                    commit('REMOVE_CART_ITEM');
                })
                .catch(err => console.error('[REMOVE_ITEM]::', err));
        },
    },
    mutations: {
        SET_COUPON_MESSAGE(state, payload) {
            state.message = payload.message;
        },
        SET_CART(state, payload) {
            state.cart.plans = payload.plans;
            state.cart.total = payload.total;
            state.cart.currency = payload.currency;
        },
        SET_CART_ITEMS(state, payload) {
            state.cartItems = payload;
        },
        ADD_CART_ITEM(state) {
            state.cartItems += 1;
        },
        REMOVE_CART_ITEM(state) {
            state.cartItems -= 1;
        },
    },
    getters: {
        // Quantidade numérica itens no carrinho ex: 1
        CART_ITEMS(state) {
            return state.cartItems;
        },
        // Lista com todos os itens do carrinho
        CART(state) {
            return state.cart;
        },
        COUPON_MESSAGE(state) {
            return state.message;
        },
    },
};
